import React from 'react'

import Avatar from 'components/Common/Avatar'

import { colors } from 'styles/theme'

type FlagProps = {
  image: string
}

const Flag = ({ image }: FlagProps) => {
  return (
    <Avatar
      height={20}
      image={image}
      width={32}
      variant="square"
      style={{
        border: `2px solid ${colors.commonWhite}`,
        borderRadius: '4px',
      }}
    />
  )
}

export default Flag
